<template src="./rentalsUnitedComponent.template.html"></template>
<script>
  import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";

  export default {
    components: {
      foliomodal
    },
    name: "rentalsUnitedComponent",
    props: ["integrationName", "parentCallback", "showRentalsUnitedClientDetails", "selectedIntegration",
      "updateRUClientDetailList", "componentName", "syncUnitToRU", "UnitId",
      "hideRentalsUnitedClientDetails", "syncUnitDetailsToRU", "deleteUnitSyncDetails",
      "IsUnitMapped", "unitId", "propertyId", "getPropertyDetailById", "getClientDetailByid",
      "activateUnitandCrsPropertyMapping", "loadUnitDetails", "updateRUComponentDropdown", "redirectToRentalsUnited", "getIntegrationList"],
    data() {
      return {
        rentalUnit: {
          username: "",
          password: "",
          showRentalUnitLogin: false,
          validationFailed: false
        },
        rentalUnitedClients: [],
        RU_UserStatusList: [
          {
            optionName: "Make Default",
            optionId: 1,
            componentName: "All",
            isDisplay: false,
            statusVal: 'Active',
            unitSync: 3
          },
          {
            optionName: "Pull Property List",
            optionId: 2,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active'
          },
          {
            optionName: "Inactivate",
            optionId: 3,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active'
          },
          {
            optionName: "Activate",
            optionId: 4,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'InActive'
          },
          {
            optionName: "Obsolete",
            optionId: 5,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active'
          },
          {
            optionName: "Push Data",
            optionId: 6,
            componentName: "unitDetail",
            isDisplay: true,
            statusVal: 'Active',
            unitSync: 1
          },
          {
            optionName: "Push Inventory, Rates, Restrictions",
            optionId: 7,
            componentName: "unitDetail",
            isDisplay: true,
            statusVal: 'Active',
            unitSync: 1
          },
          {
            optionName: "Activate",
            optionId: 9,
            componentName: "unitDetail",
            isDisplay: true,
            statusVal: 'Active',
            unitSync: 0
          },
          {
            optionName: "Inactivate",
            optionId: 8,
            componentName: "unitDetail",
            isDisplay: true,
            statusVal: 'Active',
            unitSync: 1
          },
          {
            optionName: "Delete",
            optionId: 10,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active'
          },
          {
            optionName: "Settings",
            optionId: 11,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active'
          },
          {
            optionName: "Airbnb Mapping",
            optionId: 12,
            componentName: "integrations",
            isDisplay: true,
            statusVal: 'Active',
          },
        ],
        searchText: "",
        isModalVisible: false,
        modalParams: {},
        selectedRUClient: {},
        selectedOptionId: 0,
        ShowAllAccount: 1,
        airbnbDetails: {
          showAirbnbLogin: false
        },
        isMappingModalVisible: false,
        mappingModalParams: {},
        ratePlanList:[],
        PnA_Details: [
          { id: 1, name: 'Standard' },
          { id: 2, name: 'Rate Plan' },
        ],
        PnA_Model: null,
        selectedRatePlans:[],
        showRatePlansList: false,
        previousSyncUnitorunittype: null
      };
    },
    methods: {
      deleteConnectedUnits(RUproperty, selectedRUClient) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "deleteUnitSyncDetails",
          params: {
            UnitId: RUproperty.UnitId,
            fromMapping: 1,
            rentalUnitedClient: selectedRUClient,
            crsPropertyId: RUproperty.CrsPropertyId
          },
          callback: function (error, response) {
            if (error) {
              console.log("Error in deleteConnectedUnits => ", error);
              return;
            }
            if (response) {
              console.log("response in deleteConnectedUnits", response);
              // vm.nextTick(() => {
              //   vm.getRentalUnitedClients();
              //   vm.GetCrsPropertyList(null, selectedRUClient.UserName, selectedRUClient);
              // });
              setTimeout(() => {
                vm.getRentalUnitedClients();
                vm.GetCrsPropertyList(null, selectedRUClient.UserName, selectedRUClient);
              }, 2000);
              
            }
          }
        })
      },
      getDropDownList(selectedRUclient) {
        let vm = this;
        if (vm.componentName == "integrations") {
          vm.updateRUComponentDropdown(!$(".ruComponentDropdown").hasClass("show"));
        }
        vm.RU_UserStatusList = vm.RU_UserStatusList.map((ruuserstatus) => {

          if (vm.componentName == 'integrations') {
            ruuserstatus.statusVal = 'Active'
            if (selectedRUclient.StatusId == 0 || selectedRUclient.StatusId == -1) {
              if (ruuserstatus.optionId == 4) {
                ruuserstatus.statusVal = 'Active'
              }
              else {
                ruuserstatus.statusVal = 'InActive'
              }
            }
            else if (ruuserstatus.optionId == 4 && selectedRUclient.StatusId == 1) {
              ruuserstatus.statusVal = 'InActive'
            }
            // else if (selectedRUclient.StatusId == 1 && !selectedRUclient.IsDefault && ruuserstatus.optionId == 2) {
            //   ruuserstatus.statusVal = 'InActive'
            // }
            else if (ruuserstatus.optionId == 6 || ruuserstatus.optionId == 7 || ruuserstatus.optionId == 8 || ruuserstatus.optionId == 9) {
              ruuserstatus.statusVal = 'InActive'
            }
          }
          else if (vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') {
            if (ruuserstatus.optionId == 1 || ((ruuserstatus.optionId == 6 || ruuserstatus.optionId == 7 || ruuserstatus.optionId == 8 || ruuserstatus.optionId == 9))) {
              ruuserstatus.statusVal = 'Active'
            } else {
              ruuserstatus.statusVal = 'InActive'
            }
            if ((ruuserstatus.optionId == 8 || ruuserstatus.optionId == 9) && selectedRUclient.CrsStatus == 1) {
              ruuserstatus.statusVal = 'InActive'
            }
            if ((ruuserstatus.optionId == 6 || ruuserstatus.optionId == 7 || ruuserstatus.optionId == 8) && selectedRUclient.CrsStatus == 2) {
              ruuserstatus.statusVal = 'InActive'
            }
            if (ruuserstatus.optionId == 9 && selectedRUclient.CrsStatus == 3) {
              ruuserstatus.statusVal = 'InActive'
            }
            // if ((ruuserstatus.optionId == 6 || ruuserstatus.optionId == 7) && selectedRUclient.CrsStatus == 1) {
            //   ruuserstatus.statusVal = 'InActive'
            // }
          }
          else if (vm.componentName == 'clientDetail' || vm.componentName == 'PropertyDetail') {
            ruuserstatus.statusVal = 'InActive'
            if (ruuserstatus.optionId == 1) {
              ruuserstatus.statusVal = 'Active'
            }
          }
          if (selectedRUclient.IsDefault && ruuserstatus.optionId == 1) {
            ruuserstatus.statusVal = 'InActive'
          }
          return ruuserstatus
        })
      },
      inActiveBtnClick(event) {
        var vm = this;
        if (event.target.tagName != "I" && event.target.getAttribute("title") != "DropDownMenu") {
          event.stopPropagation();
        }
      },
      showRUClientDetails(event, clientName, rentalUnitedClient) {
        var vm = this;
        if (rentalUnitedClient.StatusId != 1 || vm.selectedIntegration.IntegrationId == 10) {   //|| vm.selectedIntegration.IntegrationId == 10
          return
        }
        if (event.target.tagName != "I" && event.target.getAttribute("title") != "DropDownMenu") {
          if (vm.componentName == 'integrations') {
            vm.showRentalsUnitedClientDetails(clientName, rentalUnitedClient);

            vm.GetCrsPropertyList(event, rentalUnitedClient.UserName, rentalUnitedClient)
          }
        }
      },
      backButtonAction() {
        var vm = this;
        if (vm.selectedIntegration?.IntegrationId != 10) {
          vm.rentalUnit.showRentalUnitLogin = false;
        }
        else {
          vm.airbnbDetails.showAirbnbLogin = false;
        }
      },
      showRentalUnitedLogin(event, integrationId) {
        var vm = this;
        if (integrationId != 10) {
          vm.rentalUnit.showRentalUnitLogin = true;
        }
        else {
          vm.airbnbDetails.showAirbnbLogin = true;
        }
        vm.rentalUnit.username = ''
        vm.rentalUnit.password = ''
        vm.hideRentalsUnitedClientDetails();
        event.stopPropagation();
      },
      getRentalUnitedClients(event) {
        var vm = this;
        if (event) {
          event.stopPropagation()
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_ListOfIntegrations_RU",
          params: {
            PropertyId: vm.propertyId ? vm.propertyId : null,
            UnitId: vm.unitId ? vm.unitId : null
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in Get_ListOfIntegrations_RU => ", err);
              return;
            }
            if (response) {
              console.log("response in Get_ListOfIntegrations_RU", response);
              // vm.ShowAllAccount = !vm.ShowAllAccount
              let RuAccounts = response[0]
              vm.rentalUnitedClients.splice(0)
              vm.rentalUnitedClients = RuAccounts.filter(account => account.IntegrationId == vm.selectedIntegration.IntegrationId)
              if (vm.ShowAllAccount == 1) {
                vm.rentalUnitedClients = vm.rentalUnitedClients.filter(account => account.StatusId == 1)
              }
              // else {
              //   // vm.rentalUnitedClients = RuAccounts.filter(account => account.StatusId == 0)
              //   vm.rentalUnitedClients.splice(0, vm.rentalUnitedClients.length, ...response[0])
              // }
              // vm.rentalUnitedClients.splice(0,vm.rentalUnitedClients.length,...response[0]);
              // vm.$emit('rentalUnitedClients', vm.rentalUnitedClients)
            }
          }
        });
      },
      changeRUClientSettings(rentalUnitedClient) {
        var vm = this;
        rentalUnitedClient.IsDefault = true;
        vm.parentCallback();
      },
      pullPropertyList(rentalUnitedClient, optionId, event) {
        let vm = this;
        var userName = rentalUnitedClient.UserName
        vm.$store.dispatch("dataRequestHandler", {
          key: "PullRUPropertyList",
          params: {
            username: userName,
            password: rentalUnitedClient.Password,
            IntegrationDetails: rentalUnitedClient
          },
          callback: function (err, response) {
            console.log("response in PullRUPropertyList", response);
            console.log("Error in PullRUPropertyList => ", err);
            if (optionId == 2) {
              if (err) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Failed to pull property list from RU",
                  header: "Error!"
                });
                return;
              }
              if (response) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: rentalUnitedClient.IntegrationID == 10 ? "Successfully pulled property list from Airbnb" : "Successfully pulled property list from RU",
                  header: "Success"
                });

              } else {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: rentalUnitedClient.IntegrationID == 10 ? "Failed to pull property list from Airbnb" : "Failed to pull property list from RU",
                  header: "Error!"
                });
              }
            }
            setTimeout(() => {
              vm.GetCrsPropertyList(event, userName, rentalUnitedClient);
            }, 1000);

          }
        });
      },
      openSettingOption(rentalUnitedClient) {
        let vm = this;
        vm.selectedRUClient = {};
        vm.selectedRUClient = rentalUnitedClient;
        vm.isModalVisible = true;
        vm.modalParams = {
          popupTitle: 'Select integration type',
          popupMessage: null,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.Save_Integration_SyncunitorunittypeSettings,
          noButtonCallback: vm.closePopup,
          actionButtons: true,
        };
      },
      Save_Integration_SyncunitorunittypeSettings() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_Integration_SyncunitorunittypeSettings",
          params: {
            CrsId: vm.selectedRUClient.CrsId,
            IntegrationId: vm.selectedRUClient.IntegrationId,
            UserName: vm.selectedRUClient.UserName,
            SyncUnitorunittype: vm.selectedRUClient.SyncUnitorunittype
          },
          callback: function (error, response) {
            if (error) {
              console.log("Error in Save_Integration_SyncunitorunittypeSettings => ", error);
              vm.$store.dispatch("Error", {
                type: "error",
                message: "Error in updating",
                header: "Error!"
              });
              return;
            }
            vm.$store.dispatch("toastr", {
              type: "success",
              message: "Successfully updated",
              header: "Success!"
            });
            if ((vm.previousSyncUnitorunittype == 3 || vm.previousSyncUnitorunittype == 2) && vm.selectedRUClient.SyncUnitorunittype == 1) {
              vm.getListOfConnectedUnits(vm.selectedRUClient, [3]);
            }
            else if ((vm.previousSyncUnitorunittype == 3 || vm.previousSyncUnitorunittype == 1) && vm.selectedRUClient.SyncUnitorunittype == 2) {
              vm.getListOfConnectedUnits(vm.selectedRUClient, [1, 4]);
            }
            vm.isModalVisible = false;
            vm.selectedRUClient = {};
            vm.getRentalUnitedClients()
            vm.GetCrsPropertyList(null, vm.selectedRUClient.UserName, vm.selectedRUClient);
          }
        });
      },
      openPopup(rentalUnitedClient, optionId) {
        let vm = this;
        vm.isModalVisible = true;
        vm.selectedRUClient = {};
        vm.selectedOptionId = 0;
        vm.selectedRUClient = rentalUnitedClient;
        vm.selectedOptionId = optionId;
        var message = "";
        var title = "";
        title = vm.componentName == "integrations" ? rentalUnitedClient.IntegrationId == 10 ? "Airbnb United Account" : "Rentals United Account" : vm.componentName == 'unitTypeDetail' ?  "Unit Type Sync":"Unit Sync";

        switch (optionId) {
          case 1:
            title = "Account Default";
            message = "Do you want to Make this account as default?";
            break;
          case 2:
            message = "Do you want to pull property list?";
            break;
          case 3:
            message = "Do you want to make this account as InActive?";
            break;
          case 4:
            message = "Do you want to make this account as Active?";
            break;
          case 5:
            message = "Do you want to make this account as Obsolete?";
            break;
          case 6:
            message = vm.componentName == 'unitTypeDetail' ? "Do you want to Sync/Push Unit type?" : "Do you want to Sync/Push Unit?";
            break;
          case 7:
            message = "Do you want to Sync/Push Inventory, Rates, Restrictions?";
            break;
          case 8:
            message = vm.componentName == 'unitTypeDetail' ? "Do you want to Unsync/Inactivate Unit type?" : "Do you want to Unsync/Inactivate Unit?";
            break;
          case 9:
            message = vm.componentName == 'unitTypeDetail' ? "Do you want to sync/Activate Unit type?" : "Do you want to sync/Activate Unit?";
            break;
          case 10:
            message = "Removing this account will result in the deletion of the underlying units' accounts.";
            break;
        }
        if (optionId == 11) {
          vm.openSettingOption(rentalUnitedClient)
          return
        }
        if(optionId == 12){
          vm.openMappingModal(rentalUnitedClient)
          return
        }
        vm.modalParams = {
          popupTitle: title,
          popupMessage: message,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.updateProcess,
          noButtonCallback: vm.closePopup
        };
      },
      updateProcess(event) {
        var vm = this;
        let rentalUnitedClient = vm.selectedRUClient;
        let optionId = vm.selectedOptionId;
        console.log("optionId-----", optionId);
        var reqObj = {
          username: rentalUnitedClient.UserName,
          password: rentalUnitedClient.Password
        };
        if (optionId == 2) {
          vm.pullPropertyList(rentalUnitedClient, optionId, event);
        } else if (optionId == 1) {
          reqObj.statusId = rentalUnitedClient.StatusId;
          reqObj.isDefault = 1;
          vm.updateRULogins(reqObj);
        }
        else if (optionId == 3) {
          //0 InActive
          reqObj.statusId = 0;
          reqObj.isDefault = rentalUnitedClient.IsDefault
          vm.updateRULogins(reqObj, event);
        }
        else if (optionId == 4) {
          //1 Active
          reqObj.statusId = 1;
          reqObj.isDefault = rentalUnitedClient.IsDefault
          vm.updateRULogins(reqObj);
        }
        else if (optionId == 5) {
          //-1 Obsolete
          reqObj.statusId = -1;
          reqObj.isDefault = rentalUnitedClient.IsDefault;
          vm.updateRULogins(reqObj, event);
        }
        else if (optionId == 10) {
          // -2 Delete
          reqObj.statusId = -2;
          reqObj.isDefault = rentalUnitedClient.IsDefault;
          vm.updateRULogins(reqObj, event);
        }
        else if (optionId == 6) {
          //Push Data         
          vm.syncUnitToRU('Property Sync', rentalUnitedClient);
          // vm.pullPropertyList(rentalUnitedClient);
          // vm.getRentalUnitedClients();
        }
        else if (optionId == 7) {

          vm.$store.dispatch("dataRequestHandler", {
            key: "CheckPnA",
            params: {
              ModuleAction: "CheckPnA",
              IntegrationId: rentalUnitedClient.IntegrationId,
              UserName: rentalUnitedClient.UserName,
            },
            callback: function (err, response) {
              if (response) {
                console.log("response in CheckPnA", response);
                const isPnA_available = response.recordsets[0][0].PnA_Model;
                if(isPnA_available !== "1" && isPnA_available !== "2" && response.recordsets[0][0].IntegrationId == 10){
                  vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "warning!",
                    message: "please select Pricing and Availability model",
                  });
                  return;
                }else{
                  //Sync
                  if ((vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') && rentalUnitedClient.CrsStatus == 3) {
                    var ruSyncMethodsList = [];
                    ruSyncMethodsList.push({ IsChecked: rentalUnitedClient.SyncRates, method: 'Rates' });
                    ruSyncMethodsList.push({ IsChecked: rentalUnitedClient.SyncInventory, method: 'Inventory' });
                    ruSyncMethodsList.push({ IsChecked: rentalUnitedClient.SyncRestrictions, method: 'Restrictions' });
                    vm.syncUnitDetailsToRU(ruSyncMethodsList, rentalUnitedClient);
                  } else {
                    vm.$store.dispatch("toastr", {
                      type: "warning",
                      header: "Warning!",
                      message: "Please sync the unit"
                    });
                  }
                }
              } else {
                console.log(err);
              }
            },
          });
        }
        else if (optionId == 8) {
          //Unsync
          if (vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') {
            vm.deleteUnitSyncDetails(rentalUnitedClient);
          } else {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning!",
              message: vm.componentName == 'unitTypeDetail' ? "Please sync the unit type" : "Please sync the unit"
            });
          }
        }
        else if (optionId == 9) {
          //Activate
          if (vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') {
            vm.activateUnitandCrsPropertyMapping(true, rentalUnitedClient);
          } else {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning!",
              message: vm.componentName == 'unitTypeDetail' ? "Please sync the unit type" : "Please sync the unit"
            });
          }
        }

        vm.isModalVisible = false;
        setTimeout(() => {
          if (vm.getIntegrationList)
            vm.getIntegrationList();
        }, 3000);
        if (event) {
          event.stopPropagation();
        }
      },
      closePopup(event) {
        let vm = this;
        vm.isModalVisible = false;
        vm.isMappingModalVisible = false;
        vm.mappingModalParams = {}
        vm.selectedRUClient = {};
        vm.selectedOptionId = 0;
        vm.getRentalUnitedClients()
        if (event) {
          event.stopPropagation();
        }
      },
      updateRUClient(event, rentalUnitedClient, RU_UserStatus) {
        var vm = this;
        var optionId = RU_UserStatus.optionId;
        vm.openPopup(rentalUnitedClient, optionId);
        //vm.updateProcess(rentalUnitedClient, optionId)
        //$('.dropdown.open .dropdown-toggle').dropdown('toggle');
        $(".ruComponentDropdown").removeClass("show");
        event.stopPropagation();
      },
      updateRULogins(reqObj) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "SaveRULogins",
          params: {
            username: reqObj.username,
            password: reqObj.password,
            isDefault: reqObj.isDefault,
            statusId: reqObj.statusId,
            isConnect: false,
            PropertyId: vm.propertyId ? vm.propertyId : null,
            UnitId: vm.unitId ? vm.unitId : null
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in updateRULogins => ", err);
              return;
            }
            console.log("response in updateRULogins", response);
            if (response.recordsets[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Failed to update!!",
                header: "Error!"
              });
              return;
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Successfully updated",
                header: "Success!"
              });
              vm.getRentalUnitedClients();
              if (vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') {
                vm.loadUnitDetails(vm.selectedRUClient);
              } else if (vm.componentName == 'PropertyDetail') {
                vm.getPropertyDetailById();
              } else if (vm.componentName == 'clientDetail') {
                vm.getClientDetailByid();
              }
              if (vm.selectedOptionId == 3 || vm.selectedOptionId == 5 || vm.selectedOptionId == 10) {
                vm.redirectToRentalsUnited(event, 1);
              }
            }
          }
        });
      },
      rentalUnitedLogin() {
        let vm = this;
        if (vm.rentalUnit.username == '' || vm.rentalUnit.password == '') {
          vm.rentalUnit.validationFailed = true;
          return;
        }
        if (vm.rentalUnitedClients.find(ruClient => vm.rentalUnit.username.trim().toLowerCase() == ruClient.UserName.trim().toLowerCase())) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Account already exist with same username"
          });
          vm.rentalUnit.username = "";
          vm.rentalUnit.password = "";
          return;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "SaveRULogins",
          params: {
            username: vm.rentalUnit.username.trim(),
            password: vm.rentalUnit.password.trim(),
            isDefault: vm.rentalUnitedClients.length > 0 ? 0 : 1,
            statusId: 1,
            isConnect: true,
            PropertyId: vm.propertyId ? vm.propertyId : null,
            UnitId: vm.unitId ? vm.unitId : null
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in rentalUnitedLogin => ", err);
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Incorrect login or password",
                header: "Error!"
              });
              return;
            }
            if (response) {
              if (response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: response.recordsets[0][0].ErrorMessage,
                  header: "Error!"
                });
              } else {
                vm.rentalUnit.username = "";
                vm.rentalUnit.password = "";
                console.log("response in rentalUnitedLogin", response);
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "Login successfull!!",
                  header: "Success!"
                });
                vm.rentalUnit.showRentalUnitLogin = false;
                vm.parentCallback();
                vm.getRentalUnitedClients();
              }
            }
          }
        });
      },
      GetCrsPropertyList(event, userName, rentalUnitedClient) {
        var vm = this;
        if (rentalUnitedClient.StatusId != 1 || vm.selectedIntegration.IntegrationId == 10) {
          return
        }
        if (event && (event.target.tagName == "I" || event.target.getAttribute("title") == "DropDownMenu" || vm.componentName != "integrations")) {
          return;
        }
        vm.updateRUClientDetailList(userName, "", "All");
      },
      Save_Integration_SyncSettings(rentalUnitedClient, event, syncType) {
        let vm = this;
        switch (syncType) {
          case "SyncInventory":
            if (event.target.checked) {
              rentalUnitedClient.SyncInventory = true;
            } else {
              rentalUnitedClient.SyncInventory = false;
            }
            break;
          case "SyncRates":
            if (event.target.checked) {
              rentalUnitedClient.SyncRates = true;
            } else {
              rentalUnitedClient.SyncRates = false;
            }
            break;
          case "SyncRestrictions":
            if (event.target.checked) {
              rentalUnitedClient.SyncRestrictions = true;
            } else {
              rentalUnitedClient.SyncRestrictions = false;
            }
            break;
        }
        if ((vm.componentName == 'PropertyDetail' || vm.componentName == 'unitDetail' || vm.componentName == 'unitTypeDetail') && ((rentalUnitedClient.SyncInventory && !rentalUnitedClient.ClientSyncInventory) || (rentalUnitedClient.SyncRates && !rentalUnitedClient.ClientSyncRates) || (rentalUnitedClient.SyncRestrictions && !rentalUnitedClient.ClientSyncRestrictions))) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            message: "Could not on sync due off in client level",
            header: "Warning!"
          });
          return
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_Integration_SyncSettings",
          params: {
            ModuleAction: "Save_Integration_SyncSettings",
            SyncInventory: rentalUnitedClient.SyncInventory,
            SyncRates: rentalUnitedClient.SyncRates,
            SyncRestrictions: rentalUnitedClient.SyncRestrictions,
            CrsId: rentalUnitedClient.CrsId,
            UserName: rentalUnitedClient.UserName,
            PropertyId: vm.propertyId ? vm.propertyId : null,
            UnitId: vm.unitId ? vm.unitId : null,
            IntegrationId: rentalUnitedClient.IntegrationId
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in Save_Integration_SyncSettings", response);
              if (response && response[0] && response[0][0] && response[0][0].ErrorMessage) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error in saving sync settings",
                  header: "Error!"
                });
                return
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "Saved successfully",
                  header: "Success"
                });
                vm.getRentalUnitedClients();
              }
            }
          }
        });
      },
      saveAirbnbConnection() {
        let vm = this
        vm.$validator.validateAll().then((result) => {
          if (result) {
            vm.$store.dispatch("dataRequestHandler", {
              key: "connectIntegrationOAuth",
              params: {
                connectAcountLength: vm.rentalUnitedClients.filter(account => account.IntegrationId == 10).length,
                userName: vm.airbnbDetails.userName
              },
              callback: function (err, response) {
                if (err) {
                  console.log("Error in connectIntegrationOAuth => ", err);
                  return;
                }
                if (response) {
                  window.open(response)
                }
              }
            })
            // vm.$store.dispatch("dataRequestHandler", {
            //   key: "SaveIntegrations",
            //   params: {
            //     ModuleAction: "SaveIntegrations",
            //     crsId: null,
            //     // ClientCode: null,
            //     username: vm.airbnbDetails.userName,
            //     password: vm.airbnbDetails.password,
            //     statusId: 1,
            //     isDefault: true,
            //     UnitId: null,      //vm.unitId,
            //     PropertyId: null, // vm.propertyId,
            //     UsersPassword: null,
            //     User_ApiKey: vm.airbnbDetails.User_ApiKey,
            //     RatePlanId: null,
            //     IntegrationId: vm.selectedIntegration.IntegrationId,   //vm.$route.params.integrationId ? vm.$route.params.integrationId : vm.componentIntegrationId,
            //     EmailId: null,
            //     Integrators_UserId: null,  //vm.airbnbDetails.Integrators_UserId,
            //     PhoneNumber: null,
            //     derivedRateplanId: null,
            //     Amount: null,
            //     isPercentage: null,
            //     isPositive: null,
            //     PaymentConnectionId: vm.airbnbDetails.PaymentConnectionId,
            //     RefreshToken: vm.airbnbDetails.RefreshToken,
            //     IntegartedClientId: vm.airbnbDetails.IntegartedClientId,
            //     classid: vm.airbnbDetails.IntegratedClassId
            //   },
            //   callback: function (err, response) {

            //     if (err) {
            //       vm.$store.dispatch("toastr", {
            //         type: "error",
            //         header: "Error!",
            //         message: "Error in creating user"
            //       });
            //       return
            //     }
            //     if (response) {
            //       if (response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage) {
            //         vm.$store.dispatch("toastr", {
            //           type: "error",
            //           message: response.recordsets[0][0].ErrorMessage,
            //           header: "Error!"
            //         });
            //       } else {
            //         console.log("user fin--inactive = ", response)
            //         vm.$store.dispatch("toastr", {
            //           type: "success",
            //           header: "Success!",
            //           message: "Account Added Successfully!!"
            //         });
            //         vm.airbnbDetails.showAirbnbLogin = false;
            //         vm.parentCallback();
            //         vm.getRentalUnitedClients();
            //       }
            //     }
            //   }
            // })
          }
        })
      },
      redirectToProfileDetail(rentalUnitedClient) {
        let vm = this;
        vm.$router.push("/integrationDetail/" + vm.selectedIntegration.IntegrationId + "/" + rentalUnitedClient.IntegartedClientId + "/" + rentalUnitedClient.RefreshToken);
      },
      getListOfConnectedUnits(selectedRUClient, type) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "getListOfConnectedUnits",
          params: selectedRUClient,
          callback: function (err, response) {
            if (err) {
              console.log("Error in getListOfConnectedUnits => ", err);
              return;
            }
            if (response) {
              for (let unit of response[0]) {
                if (type.includes(unit.unitSetId)) {
                  vm.deleteConnectedUnits(unit, selectedRUClient)
                }
              }
            }
          }
        })
      },
      openMappingModal(rentalUnitedClient){
        let vm = this;
        vm.getAirbnbMappingFnc();
        vm.selectedRUClient = {};
        vm.selectedRUClient = rentalUnitedClient;
        vm.isModalVisible = false;
        vm.isMappingModalVisible = true;
        vm.getRatePlanList();
        vm.getAirbnbMappingFnc();
        vm.mappingModalParams = {
          popupTitle: `Save Airbnb Mapping for ${rentalUnitedClient.UserName} Account`,
          popupMessage: null,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.saveAirbnbMappingFnc,
          noButtonCallback: vm.closePopup,
          actionButtons: true,
        };
      },
      savePnA_model() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_PnA_Model",
          params: {
            IntegratedUserName: vm.selectedRUClient.UserName, 
            PnA_Model: vm.PnA_Model,
          },
          callback: function (error, response) {
            if(error){
              console.log('error', error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error!",
                message: `Failed to save Airbnb Mapping`
              });
            }else{
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: `Airbnb Mapping saved successfully`
              });
              console.log('response', response);
              $("#RateplansList").hide();
            }
          }
        });
      },
      saveAirbnbMappingFnc() {
        let vm = this;
        if(vm.PnA_Model != 2){
          vm.selectedRatePlans = [];
          vm.savePnA_model();
          vm.isMappingModalVisible = false;
          return;
        }
        vm.savePnA_model();
        vm.$store.dispatch("dataRequestHandler", {
            key: "SaveAirbnbMapping",
            params: {
              IntegratedUserName: vm.selectedRUClient.UserName, 
              IntegrationID: vm.selectedRUClient.IntegrationId,
              RatePlanDetails: vm.selectedRatePlans,
              ExternalRatePlanID: null,
            },
            callback: function (error, response) {
              if(error){
                console.log('error', error);
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: `Failed to save Airbnb Mapping`
                });
              }else{
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: `Airbnb Mapping saved successfully`
                });
                console.log('response', response);
                $("#RateplansList").hide();
                vm.PnA_Model = null;
                vm.selectedRatePlans = [];
              }
              vm.isMappingModalVisible = false;
              vm.getAirbnbMappingFnc();
              vm.selectedRUClient = {};
              vm.getRentalUnitedClients();
            }
          });
      },
      getAirbnbMappingFnc() {
        let vm = this;
        vm.get_PnA_Value();
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetAirbnbMapping",
          params: {
            IntegratedUserName: vm.selectedRUClient.UserName
          },
          callback: function (error, response) {
            if(error){
              console.log('GetAirbnbMapping error', error);
            }else{
              console.log('GetAirbnbMapping response', response);
              vm.selectedRatePlans = response;
            }
            vm.getRentalUnitedClients()
          }
        });
      },
      getRatePlanList() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_RatePlanList",
          params: {
            ModuleAction: "Get_RatePlanList",
            ratePlanId: ''
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_RatePlanList", err);
            }
            if (response) {
              console.log("response of Get_RatePlanList", response);
              if (response[1]) {
                vm.ratePlanList = response[1];
              }
            }
          }
        });
      },
      get_PnA_Value() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPnA_Value",
          params: {
            IntegratedUserName: vm.selectedRUClient.UserName
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in GetPnA_Value", response);
              vm.PnA_Model = response && response[0] && response[0].PnA_Model || null;
            }
          }
        });
      },
      showRatePlansFnc() {
        this.showRatePlansList = !this.showRatePlansList;
        setTimeout(() => {
          $("#RateplansList").show();
        }, 10);
      },
      addRatePlans(ratePlan) {
        let vm = this;
        vm.selectedRatePlans.push(ratePlan)
        var index = vm.ratePlanList.indexOf(ratePlan);
        if (index > -1) {
          vm.ratePlanList.splice(index, 1);
        }
      },
      // removeSelectedRatePlan(ratePlan) {
      //   let vm = this;
      //   const index = vm.selectedRatePlans.findIndex(selectedRatePlan => selectedRatePlan.RatePlanId === ratePlan.RatePlanId);
      //   if (index > -1) {
      //     vm.selectedRatePlans.splice(index, 1);
      //   }
      //   vm.ratePlanList.push(ratePlan);
      //   vm.showRatePlansFnc();
      // },
      removeSelectedRatePlan(ratePlan) {
        let vm = this;
        const index = vm.selectedRatePlans.findIndex(selectedRatePlan => selectedRatePlan.RatePlanId === ratePlan.RatePlanId);
        if (index > -1) {
          vm.selectedRatePlans.splice(index, 1);
        }
        // Check if ratePlan is already in ratePlanList
        const ratePlanListIndex = vm.ratePlanList.findIndex(rp => rp.RatePlanId === ratePlan.RatePlanId);
        if (ratePlanListIndex === -1) {
          vm.ratePlanList.push(ratePlan);
        }
        vm.showRatePlansFnc();
      },
      getRatePlanName(selectedRatePlan) {
        const ratePlan = this.ratePlanList.find(plan => plan.RatePlanId === selectedRatePlan.RatePlanId);
        return ratePlan ? ratePlan.RatePlan_Name : selectedRatePlan.RatePlan_Name;
      },
      checkDefaultRatePlan() {
        if (this.PnA_Model == 2) {
            const defaultRatePlan = { RatePlanId: 140, RatePlan_Name: "Standard rate plan"}
            const alreadyAdded = this.selectedRatePlans.some(plan => plan.RatePlanID === 140);
            if (!alreadyAdded) {
                this.selectedRatePlans.push(defaultRatePlan);
            }
        }
      },
    },
    computed: {
      filteredRatePlan() {
        const selectedValues = this.selectedRatePlans.map(plan => plan.RatePlanId);
        const filteredValues = this.ratePlanList.filter(value => !selectedValues.includes(value.RatePlanId));
        return filteredValues;
      }
    },
    mounted() {
      var vm = this;
      vm.getRentalUnitedClients();
      vm.getRatePlanList();
      vm.getAirbnbMappingFnc();  
      $(document).click(function (e) {
        $("#RateplansList").hide();
      });
    },
    watch: {
      'selectedRUClient.SyncUnitorunittype'(newVal, oldVal) {
        if (oldVal != newVal) {
          this.previousSyncUnitorunittype = oldVal;
          // this.deleteUnitSyncDetails(this.selectedRUClient);

        }
      },
    }
  }
</script>